import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";

@Component({
	templateUrl: './set_user_ban.component.html'
})
export class SetUserBanModalComponent extends BaseSupportModalComponent {
	userId: string;
	email: string;
	message: string = 'Нарушение правил пользования';

	async ok() {
		if (confirm(`Вы уверены, что хотите заблокировать аккаунт: ${this.title}?`)) {
			await this.supportService.setBan(this.userId, this.message, this.spreader.base.comment).toPromise();

			this.execute();
		}
	}
}
